<template>
  <div>
    <b-img src="/images/hayek_logo.png" center></b-img>
    <b-row>
      <b-col md="2"></b-col>
      <b-col md="8">
        <b-card class="mt-3">
          <b-form @submit="onSubmit" @submit.stop.prevent>
            <div v-if="errors" class="alert alert-danger">
              {{ errors }}
            </div>
            <b-form-group id="input-group-1" label="Email address:">
              <b-form-input
                id="input-1"
                v-model="form.email"
                type="email"
                placeholder="Enter email"
                :class="{ 'is-invalid': validation.hasError('form.email') }"
                required
              ></b-form-input>
              <div class="invalid-feedback" v-if="validation.hasError('form.email')">
                {{ validation.firstError('form.email') }}
              </div>
            </b-form-group>
            <label for="text-password">Password</label>
            <b-form-input
              type="password"
              name="password"
              v-model="form.password"
              id="text-password"
              aria-describedby="password-help-block"
              :class="{ 'is-invalid': validation.hasError('form.password') }"
              required
            ></b-form-input>
            <div class="invalid-feedback" v-if="validation.hasError('form.password')">
              {{ validation.firstError('form.password') }}
            </div>
            <hr />
            <b-button type="submit" variant="primary">
              Sign In
            </b-button>
            <br />
            <br />
            <small>
              Forgot your password? <a href="/reset-password">Reset Password</a>
            </small>
          </b-form>
        </b-card>
      </b-col>
      <b-col md="2"></b-col>
    </b-row>
  </div>
</template>

<script>
import { HTTP } from "../../http-common";
import SimpleVueValidation from "simple-vue-validator";

const Validator = SimpleVueValidation.Validator;

export default {
  data() {
    return {
      form: {
        email: "",
        password: "",
      },
      errors: "", // Initialize as an empty string
    };
  },
  mixins: [SimpleVueValidation.mixin], // Attach SimpleVueValidation
  validators: {
    "form.email": function (value) {
      return Validator.value(value)
        .required("Email is required.")
        .email("Invalid email address.");
    },
    "form.password": function (value) {
      return Validator.value(value).required("Password is required.");
    },
  },
  methods: {
    async onSubmit(event) {
      event.preventDefault();

      // Validate form fields before submission
      this.$validate().then(async (success) => {
        if (!success) {
          return; // Stop form submission if validation fails
        }

        try {
          const response = await HTTP.post("/auth", this.form);
          localStorage.setItem("jwt", response.data.token);
          localStorage.setItem("isAuthenticated", true);
          localStorage.setItem("name", response.data.data.name_full);
          localStorage.setItem("company_id", response.data.data.company_id);
          localStorage.setItem("avatar", response.data.data.avatar);
          localStorage.setItem("pusher_user", response.data.data.pusher_user);
          localStorage.setItem("admin", response.data.data.opt_admin);
          localStorage.setItem("underwriter", response.data.data.opt_underwriter);
          window.location = "/dashboard";
        } catch (error) {
          // Handle 401 Unauthorized error
          if (error.response && error.response.status === 401) {
            this.errors = "Unauthorized: Invalid email or password.";
          } else if (error.response) {
            // Handle other API errors
            this.errors = `Error: ${error.response.status} - ${error.response.statusText}`;
          } else {
            // Handle unexpected errors
            this.errors = "An unexpected error occurred. Please try again.";
          }
        }
      });
    },
  },
};
</script>

<style scoped>
.invalid-feedback {
  display: block;
}
</style>
